

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import { Binary } from '@angular/compiler';

export interface CommunicationGroupParameter extends Parameter {
    searchTerm: number;
    orderBy: string;

}

export interface CommunicationGroup {
   
    id?: any;
    tenantId: any;
    branchId: any;
    name:any;
   // scheduledDate:any;
   // runOnlyOnce:any;
   // templateType:any;
    groupForWhom:string;
    patient:string;
    employees:string;
    physicians:string;
    //filterMinAge:string;
    //filterMaxAge:string;
   // filterGender:string;
    filterLocations:string;
    filterDepartment:string;
    filterPhysician:string;
    referrals:string;
    medicalTourism:string;
    isActive:string;
  templateDescription:string;
    
    parameters?: CommunicationGroupParameter[];
    links?: any;
}


export abstract class CommunicationGroupData {
    //abstract fireRequest(data: Department, method: string): Observable<any>;
    abstract list(url: string): Observable<CommunicationGroup[]>;
    abstract create(url: string, data: CommunicationGroup): Observable<CommunicationGroup[]>;
    abstract update(url: string, data: CommunicationGroup): Observable<CommunicationGroup>;
    abstract delete(url: string): Observable<any>;
}
